import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

interface Props {
  onBack: () => void;
  onSave?: () => void;
}

export const ParcelSettingsView: React.FC<Props> = ({ onBack, onSave }) => {
  const [showByPermission, setShowByPermission] = useState(false);
  const [showOldParcels, setShowOldParcels] = useState(true);
  const [showDuringStayOnly, setShowDuringStayOnly] = useState(false);

  const handleSave = () => {
    if (onSave) onSave();
  };

  return (
    <div className="bg-white min-h-[480px] rounded-xl p-6 sm:p-8 font-prompt space-y-6 flex flex-col justify-between">
      <div className="space-y-8">
        {/* Top Header */}
        <div className="flex items-center gap-3 pb-2">
          <button
            type="button"
            onClick={onBack}
            className="w-8 h-8 rounded-full border border-slate-300 hover:border-slate-400 bg-white flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors cursor-pointer"
            title="ย้อนกลับ"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
          <h1 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
            ตั้งค่าพัสดุ
          </h1>
        </div>

        {/* Setting Items Card */}
        <div className="max-w-3xl space-y-6 pt-2">
          <h2 className="text-lg font-bold text-slate-800">ตั้งค่าพัสดุ</h2>

          <div className="space-y-6">
            {/* Item 1 */}
            <div className="flex items-center justify-between gap-4">
              <span className="text-xs sm:text-sm text-slate-700 font-normal">
                แสดงผลตามสิทธิ์ (เปิดใช้งานเพื่อแยกการแสดงผลระหว่างเจ้าของกรรมสิทธิ์/ผู้อยู่อาศัย และ ผู้เช่า)
              </span>
              <button
                type="button"
                role="switch"
                aria-checked={showByPermission}
                onClick={() => setShowByPermission(!showByPermission)}
                className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors shrink-0 cursor-pointer ${
                  showByPermission ? 'bg-blue-700 justify-end' : 'bg-slate-300 justify-start'
                }`}
              >
                <div className="bg-white w-4 h-4 rounded-full shadow-md" />
              </button>
            </div>

            {/* Item 2 */}
            <div className="flex items-center justify-between gap-4">
              <span className="text-xs sm:text-sm text-slate-700 font-normal">
                แสดงผลพัสดุเก่า (ก่อนวันที่ 17/11/2565)
              </span>
              <button
                type="button"
                role="switch"
                aria-checked={showOldParcels}
                onClick={() => setShowOldParcels(!showOldParcels)}
                className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors shrink-0 cursor-pointer ${
                  showOldParcels ? 'bg-blue-700 justify-end' : 'bg-slate-300 justify-start'
                }`}
              >
                <div className="bg-white w-4 h-4 rounded-full shadow-md" />
              </button>
            </div>

            {/* Item 3 */}
            <div className="flex items-center justify-between gap-4">
              <span className="text-xs sm:text-sm text-slate-700 font-normal">
                แสดงผลพัสดุเฉพาะช่วงเวลาที่เข้ามาอยู่อาศัยภายในโครงการ (เปิดใช้งานเพื่อแสดงพัสดุเฉพาะช่วงเวลาที่เข้ามาอยู่อาศัย)
              </span>
              <button
                type="button"
                role="switch"
                aria-checked={showDuringStayOnly}
                onClick={() => setShowDuringStayOnly(!showDuringStayOnly)}
                className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors shrink-0 cursor-pointer ${
                  showDuringStayOnly ? 'bg-blue-700 justify-end' : 'bg-slate-300 justify-start'
                }`}
              >
                <div className="bg-white w-4 h-4 rounded-full shadow-md" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Save Button */}
      <div className="flex justify-end pt-8">
        <button
          type="button"
          onClick={handleSave}
          className="px-8 py-2.5 bg-blue-700 hover:bg-blue-800 text-white rounded-lg text-sm font-semibold transition-colors shadow-xs cursor-pointer"
        >
          บันทึก
        </button>
      </div>
    </div>
  );
};
